import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createVNode as _createVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "b-page-wrapper b-page-wrapper--gray h-flex h-flex-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ForgotPasswordPage = _resolveComponent("ForgotPasswordPage")!
  const _component_LinkSentPage = _resolveComponent("LinkSentPage")!
  const _component_FwIcon = _resolveComponent("FwIcon")!
  const _component_FwPopup = _resolveComponent("FwPopup")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_FwPopup, {
      centered: true,
      isFixed: true,
      "max-width": _ctx.isDesktop() ? "420px" : "calc(100% - 20px)",
      width: "90%",
      popupClass: "b-popup-style--no-shadow",
      allowBackgroundScrolling: true,
      disableClosingOnClickOutside: true,
      popupBackground: "#fff",
      popupRadius: "20px"
    }, {
      body: _withCtx(() => [
        (!_ctx.linkSentPage)
          ? (_openBlock(), _createBlock(_component_ForgotPasswordPage, {
              key: 0,
              onOnSubmit: _ctx.goToSendLink
            }, null, 8, ["onOnSubmit"]))
          : (_openBlock(), _createBlock(_component_LinkSentPage, { key: 1 }))
      ]),
      arrowBack: _withCtx(() => [
        (!_ctx.linkSentPage)
          ? (_openBlock(), _createBlock(_component_FwIcon, {
              key: 0,
              icon: "arrow-left-alt",
              size: "20",
              color: "#27DBBD",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.go(-1)))
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["max-width"])
  ]))
}